RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    // shared column view used by all post detail widgets
    widgets.PostDetailsColumnView = RivalIQ.apps.Dashboard.views.ColumnWidgets.extend({
        columnWidth: 3,
        panelView: undefined,
        className: 'facebook-insights-post-details',

        dashboardModelEvents: {
            'change': 'reload'
        },

        getPngView: function (child) {
            return child.getView();
        },

        getPdfView: function (child) {
            return child.getView();
        },

        getPptView: function (child) {
            return child.getView();
        },

        loadData: function () {
            const me = this;

            const postType = me.dashboardModel.metric.build({
                property: 'type'
            });

            return postType.fetch().done(function (metric) {
                me.postType = metric;
            });
        },

        refresh: function () {
            const me = this;
            me.render();
        },

        isEmpty: function () {
            const me = this;

            return !me.postType.getValue({
                format: false
            }) ||
                RivalIQ.apps.Dashboard.views.ColumnWidgets.prototype.isEmpty.call(me);
        },

        emptyView: Marionette.ItemView.extend({
            template: '#facebookInsightsPostDetailMissing'
        }),

        initialize: function () {
            const me = this;
            me.collection = me.dashboardModel.getWidgets();
        }
    });


    widgets.PostDetailsWidgetBase = RivalIQ.apps.Dashboard.models.Widget.extend({
        title: '',
        description: '',
        viewMore: false,
        propsToSerializeForExport: [],
        scheduledExportAdvancedSettingsEnabled: false,
        processProps: function (props) {
            const me = this;

            if (!me.metric) {
                me.metric = new RivalIQ.models.MetricDefinition({
                    concept: RivalIQ.metrics.id.FACEBOOK_INSIGHTS_POST_DETAILS,
                    companyId: props.companyId,
                    channel: props.channel,
                    objectType: _.get(props, ['objectType'], 'post'),
                    postId: props.postId
                });
            }

            return props;
        },
        widgetDefinitions: function () {
            return [];
        },
        filter: function () {
            const me = this;
            return !RivalIQ.props.channelAccess(me.getProps());
        }

    });

});
